'use strict';

exports.__esModule = true;

var _templateObject = _taggedTemplateLiteral(['\n  &::-webkit-scrollbar {\n    width: ', ';\n  }\n\n  &::-webkit-scrollbar-button:start:decrement,\n  &::-webkit-scrollbar-button:end:increment {\n    background-color: transparent;\n    display: block;\n    height: 0;\n  }\n\n  &::-webkit-scrollbar-track-piece {\n    background-color: transparent;\n    border-radius: 0;\n    border-bottom-right-radius: ', ';\n    border-bottom-left-radius: ', ';\n  }\n\n  &::-webkit-scrollbar-thumb:vertical {\n    background-color: ', ';\n    border-radius: ', ';\n  }\n\n  &::-webkit-scrollbar-thumb:horizontal {\n    background-color: ', ';\n    border-radius: ', ';\n  }\n'], ['\n  &::-webkit-scrollbar {\n    width: ', ';\n  }\n\n  &::-webkit-scrollbar-button:start:decrement,\n  &::-webkit-scrollbar-button:end:increment {\n    background-color: transparent;\n    display: block;\n    height: 0;\n  }\n\n  &::-webkit-scrollbar-track-piece {\n    background-color: transparent;\n    border-radius: 0;\n    border-bottom-right-radius: ', ';\n    border-bottom-left-radius: ', ';\n  }\n\n  &::-webkit-scrollbar-thumb:vertical {\n    background-color: ', ';\n    border-radius: ', ';\n  }\n\n  &::-webkit-scrollbar-thumb:horizontal {\n    background-color: ', ';\n    border-radius: ', ';\n  }\n']);

var _theme = require('../theme');

var _theme2 = _interopRequireDefault(_theme);

var _styledComponents = require('styled-components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var scrollbar = function scrollbar() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '6px';
  var borderRadius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '3px';
  return (0, _styledComponents.css)(_templateObject, width, borderRadius, borderRadius, _theme2.default.greyLight, borderRadius, _theme2.default.greyLight, borderRadius);
};

exports.default = scrollbar;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/qu-react-sdk/lib/styles/mixins/scrollbar.js
// module id = 1028
// module chunks = 0